var _defs, _rect, _rect2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalloon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "CG6cGJszgSfb03Ppijnpna",
    x1: 16.678,
    x2: 33.141,
    y1: -2.989,
    y2: 42.244,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 123",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f44f5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e52030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CG6cGJszgSfb03Ppijnpnb",
    x1: 16.028,
    x2: 32.321,
    y1: -2.619,
    y2: 42.144,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 129",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fec52b"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 5,
    x: 20,
    y: 37,
    fill: "#5c2415"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 5,
    x: 27,
    y: 37,
    fill: "#5c2415"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CG6cGJszgSfb03Ppijnpna)",
    d: "M39,17c0,7.68-6.58,16.58-11,22H20C15.58,33.58,9,24.68,9,17a15,15,0,1,1,30,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c2620e",
    d: "M20.5,41h7a.5.5,0,0,1,.5.5V44a1,1,0,0,1-1,1H21a1,1,0,0,1-1-1V41.5A.5.5,0,0,1,20.5,41Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CG6cGJszgSfb03Ppijnpnb)",
    d: "M26,39H22c-3.4-11-6-26-.86-36.73a15.28355,15.28355,0,0,1,5.72,0C32,13,29.25,28,26,39Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloon);
export default __webpack_public_path__ + "static/media/balloon.55f8848e6657224843a60b4895fc7cab.svg";
export { ForwardRef as ReactComponent };